<template>
    <div class="user_info_block">
        <div class="user_info">
            <div class="user_profile_pic">
                <img src="@/assets/images/icons/user_verified_icon.svg" />
            </div>
            <div class="user_data">
                <h3>Assign the Verifier</h3>
                <p class="user_info_desc">Employer requested you to update the verifier</p>
                <p class="user_info_desc">Intiated on <span>{{checkProperty(caseDetails, 'initiateOn')| formatDate }}</span></p>
            </div>
        </div>
        
        <button class="IB_primary-btn" @click="assignVerifier()">Assign Verifier</button>
        
    <inviteVerifier v-if="requestAddVerifier" @closeAddVerifierPopUp="closeAddVerifierPopUp" :isCallFromBen="isCallFromBen" :caseDetails="caseDetails"
   />
    </div>
</template>
 
  <script>
  import inviteVerifier from "@/views/i-9Module/inviteVerifier.vue";

  export default {
    components: {
        inviteVerifier,
    },
    data() {
      return {
        requestAddVerifier:false,
        isCallFromBen:true
      };
    },
    props:{
        caseDetails:null
    },
    methods: {
        assignVerifier(){
            this.requestAddVerifier=true
            this.isCallFromBen=false
        },
        closeAddVerifierPopUp(data){
            this.requestAddVerifier=false;
            this.$emit('reloadPetition', data)
        },
    },
    mounted() {
    },
  };
  </script>